<section class="income-page" aria-label="Ingresos y transferencias">
  <!-- El título de esta pantalla ya lo muestra el encabezado del dashboard
       (moduleTitle()/moduleDescription() en dashboard.component.ts) --
       antes se repetía aquí también ("Ingresos y transferencias" dos veces
       seguidas). El botón "Agregar método" se movió directo a la pestaña
       "Métodos de cobro" (junto a las tarjetas que registra), en vez de
       vivir en un encabezado aparte arriba de todo. -->

  <div class="summary-grid" aria-label="Resumen financiero">
    <article class="summary-card">
      <span class="summary-icon"><i class="bi bi-graph-up-arrow"></i></span>
      <div>
        <small>Total generado (bruto)</small>
        <strong>{{ totalGeneratedGross() | currency: 'USD' }}</strong>
        <span>Histórico completo, antes de comisión</span>
      </div>
    </article>
    <!-- Corrección pedida: la deuda de TU NEGOCIO hacia TuSala vivía solo
         hasta el final de la pantalla (dentro de "Estado de cuenta") -- con
         la misma relevancia visual que "Total generado" (justo al lado),
         no como un dato secundario al final del recorrido. -->
    <article class="summary-card debt-card" *ngIf="businessOwesCompany() > 0">
      <span class="summary-icon"><i class="bi bi-exclamation-triangle-fill"></i></span>
      <div>
        <small>Debes a TuSala</small>
        <strong>{{ businessOwesCompany() | currency: 'USD' }}</strong>
        <span>Comisión sin cubrir</span>
      </div>
    </article>
    <article class="summary-card balance-card">
      <span class="summary-icon"><i class="bi bi-wallet2"></i></span>
      <div>
        <small>Total por recibir de TuSala</small>
        <strong>{{ availableBalance() | currency: 'USD' }}</strong>
        <span>{{ pendingBreakdownLabel() || (data()?.balance?.payments || 0) + ' pagos vía pasarela sin liquidar (neto de comisión)' }}</span>
      </div>
    </article>
    <article class="summary-card">
      <span class="summary-icon"><i class="bi bi-arrow-left-right"></i></span>
      <div>
        <small>Destinos registrados</small>
        <strong>{{ data()?.methods?.length || 0 }}</strong>
        <span>Transferencia bancaria</span>
      </div>
    </article>
    <article class="summary-card">
      <span class="summary-icon"><i class="bi bi-shield-check"></i></span>
      <div>
        <small>Total transferido</small>
        <strong>{{ (data()?.balance?.paid_total || 0) | currency: 'USD' }}</strong>
        <span>Registrado por TuSala</span>
      </div>
    </article>
  </div>

  <!-- Liquidación / estado de cuenta: deja claro quién le debe a quién al
       cierre de mes, separando el dinero que pasó por la pasarela de TuSala
       del que el negocio recibió directamente por otro medio. -->
  <section class="content-section settlement-panel" aria-label="Estado de cuenta y liquidación">
    <div class="settlement-head">
      <div>
        <span class="eyebrow">ESTADO DE CUENTA</span>
        <h3>Liquidación mensual</h3>
        <p>Comisión de la plataforma sobre el total generado, sin importar el origen. Aquí ves qué le corresponde a tu negocio y a TuSala.</p>
      </div>
    </div>

    <div class="settlement-grid">
      <div class="settlement-cell">
        <span class="settlement-label">Total del periodo vigente</span>
        <strong>{{ (origin()?.total_gross ?? 0) | currency: 'USD' }}</strong>
        <small>Reservas aún sin agrupar en una liquidación -- no incluye lo que ya está en "Total generado (bruto)" de arriba</small>
      </div>
      <div class="settlement-cell">
        <span class="settlement-label">Cobrado por TuSala</span>
        <strong>{{ (origin()?.platform_gross ?? 0) | currency: 'USD' }}</strong>
        <small>Pagos vía la pasarela (enlace de pago)</small>
      </div>
      <div class="settlement-cell">
        <span class="settlement-label">Cobrado por tu negocio (externo)</span>
        <strong>{{ (origin()?.external_gross ?? 0) | currency: 'USD' }}</strong>
        <small>El cliente te pagó por otro medio (efectivo, transferencia, etc.)</small>
      </div>
      <div class="settlement-cell">
        <span class="settlement-label">Comisión de la plataforma ({{ origin()?.commission_rate ?? 0 }}%)</span>
        <strong>-{{ (origin()?.commission_amount ?? 0) | currency: 'USD' }}</strong>
        <small>Se aplica sobre el total, sin importar el origen</small>
      </div>
    </div>

    <div class="settlement-position" [class.to-company]="businessOwesCompany() > 0">
      <i class="bi" [class.bi-cash-stack]="companyOwesBusiness() > 0" [class.bi-arrow-up-circle]="businessOwesCompany() > 0"></i>
      <div>
        <small>Resultado al cierre de mes (periodo vigente)</small>
        <ng-container *ngIf="companyOwesBusiness() > 0">
          <strong>TuSala te debe {{ companyOwesBusiness() | currency: 'USD' }}</strong>
          <span>Es el dinero cobrado por TuSala menos la comisión. Se te transferirá según la liquidación.</span>
        </ng-container>
        <ng-container *ngIf="businessOwesCompany() > 0 && companyOwesBusiness() <= 0">
          <strong>Tu negocio debe {{ businessOwesCompany() | currency: 'USD' }} a TuSala</strong>
          <span>Porque el cliente te pagó por otro medio y la comisión de TuSala sobre ese monto no está cubierta por la pasarela. Puedes pagarlo ahora mismo, sin esperar a que termine el mes.</span>
        </ng-container>
        <ng-container *ngIf="companyOwesBusiness() <= 0 && businessOwesCompany() <= 0">
          <strong>Cuentas en equilibrio</strong>
          <span>No hay montos pendientes entre tu negocio y TuSala.</span>
        </ng-container>
      </div>
      <button
        type="button"
        class="action-btn debt-position-pay-btn"
        *ngIf="businessOwesCompany() > 0 && companyOwesBusiness() <= 0"
        [disabled]="closingCurrentDebt()"
        (click)="payCurrentDebtNow()"
      >{{ closingCurrentDebt() ? 'Actualizando…' : 'Pagar ahora' }}</button>
    </div>
    <p class="settlement-debt-hint" *ngIf="debtSettlements().length">
      <i class="bi bi-clock-history" aria-hidden="true"></i>
      Consulta el detalle de cada periodo facturado en la pestaña <strong>Comisión pendiente</strong>.
    </p>
  </section>

  <app-admin-tabs
    [tabs]="incomeTabs"
    [active]="activeTab()"
    ariaLabel="Secciones de ingresos y transferencias"
    (tabSelect)="selectTab($event)"
  ></app-admin-tabs>

  <section
    *ngIf="activeTab() === 'metodos'"
    id="panel-metodos-de-cobro"
    class="content-section tab-panel"
    role="tabpanel"
    aria-labelledby="tab-metodos-de-cobro"
  >
    <div class="section-heading">
      <div>
        <span class="eyebrow">DESTINOS DE TRANSFERENCIA</span>
        <h3 id="methods-title">Métodos de cobro</h3>
      </div>
      <div class="section-heading-actions">
        <span class="security-label"><i class="bi bi-lock"></i> Información cifrada</span>
        <button type="button" class="primary-button" (click)="openCreate()">
          <i class="bi bi-plus-lg" aria-hidden="true"></i>
          Agregar método
        </button>
      </div>
    </div>

    <div class="method-grid" *ngIf="data()?.methods?.length; else emptyMethods">
      <article class="method-card" *ngFor="let method of data()?.methods; trackBy: trackMethod">
        <div class="method-card-header">
          <span class="method-icon"><i class="bi bi-bank"></i></span>
          <span class="method-badge" [class.primary-badge]="method.is_primary">
            {{ method.is_primary ? 'Principal' : 'Alternativo' }}
          </span>
        </div>
        <div class="method-details">
          <h4>{{ method.label }}</h4>
          <p>{{ method.institution_name }}</p>
          <strong>{{ method.method_type === 'bank_transfer' ? method.account_number : 'Entrega en efectivo' }}</strong>
        </div>
        <dl>
          <div><dt>Titular</dt><dd>{{ method.account_holder }}</dd></div>
          <div><dt>Tipo</dt><dd>{{ methodType(method.method_type) }}</dd></div>
        </dl>
        <div class="method-actions">
          <button type="button" class="secondary-button" (click)="openEdit(method)">
            <i class="bi bi-pencil-square"></i> Editar
          </button>
          <button
            *ngIf="!method.is_primary"
            type="button"
            class="secondary-button"
            (click)="requestPrimary(method)"
          >
            <i class="bi bi-star"></i> Hacer principal
          </button>
          <button
            *ngIf="!method.is_primary"
            type="button"
            class="danger-button"
            (click)="requestArchive(method)"
            aria-label="Desactivar método"
          >
            <i class="bi bi-trash3"></i>
          </button>
        </div>
      </article>
    </div>

    <ng-template #emptyMethods>
      <div class="empty-state" *ngIf="!loading()">
        <i class="bi bi-credit-card-2-front"></i>
        <h4>Aún no tienes métodos registrados</h4>
        <p>Agrega una cuenta para que TuSala pueda identificar tu destino preferido.</p>
        <button type="button" class="secondary-button" (click)="openCreate()">Agregar primer método</button>
      </div>
    </ng-template>
  </section>

  <section
    *ngIf="activeTab() === 'reservas'"
    id="panel-pagos-de-reservas"
    class="content-section tab-panel"
    role="tabpanel"
    aria-labelledby="tab-pagos-de-reservas"
  >
    <div class="section-heading">
      <div>
        <span class="eyebrow">ACTIVIDAD RECIENTE</span>
        <h3 id="transactions-title">Pagos de reservas</h3>
      </div>
      <span class="count-badge">{{ data()?.reservation_payments_total || 0 }} pagos</span>
    </div>
    <p class="commission-note"><i class="bi bi-info-circle"></i> El monto que se te transfiere ya descuenta la comisión de la plataforma. El total mostrado es tu dinero neto.</p>
    <div class="table-shell">
      <table>
        <thead><tr><th>Fecha</th><th>Espacio</th><th>Reserva</th><th class="amount">Total cobrado</th><th class="amount">Tu monto neto</th></tr></thead>
        <tbody>
          <tr *ngFor="let payment of data()?.reservation_payments; trackBy: trackPayment">
            <td data-label="Fecha">{{ payment.payment_date | esDate: 'mediumDate' }}</td>
            <td data-label="Espacio">{{ payment.space_title }}</td>
            <td data-label="Reserva">#{{ payment.business_reservation_number || payment.reservation_id }}</td>
            <td data-label="Total cobrado" class="amount">{{ (payment.gross_amount ?? payment.amount) | currency: 'USD' }}</td>
            <td data-label="Tu monto neto" class="amount amount-value">{{ (payment.net_amount ?? payment.amount) | currency: 'USD' }}</td>
          </tr>
          <tr *ngIf="!loading() && !data()?.reservation_payments?.length">
            <td colspan="5" class="empty-row">Este negocio todavía no posee pagos de reservas.</td>
          </tr>
        </tbody>
      </table>
    </div>
    <app-pagination [page]="data()?.reservation_payments_page || 1" [pages]="reservationPaymentsPages()" [total]="data()?.reservation_payments_total || 0" [limit]="data()?.reservation_payments_limit || paymentsLimit()" [disabled]="loading()" itemLabel="pagos" ariaLabel="Paginación de pagos de reservas" (pageChange)="goToPaymentsPage($event)"></app-pagination>
  </section>

  <section
    *ngIf="activeTab() === 'transferencias'"
    id="panel-transferencias"
    class="content-section tab-panel"
    role="tabpanel"
    aria-labelledby="tab-transferencias"
  >
    <div class="section-heading">
      <div>
        <span class="eyebrow">HISTORIAL</span>
        <h3 id="settlements-title">Transferencias registradas</h3>
      </div>
      <span class="count-badge">{{ data()?.settlements_total || 0 }} liquidaciones</span>
    </div>
    <div class="settlement-grid" *ngIf="transferHistory().length; else emptySettlements">
      <article class="settlement-card" *ngFor="let transfer of transferHistory(); trackBy: trackTransfer">
        <header>
          <div>
            <small>{{ transfer.performed_at | esDate: 'medium' }}</small>
            <strong>{{ transfer.amount | currency: 'USD' }}</strong>
          </div>
          <span class="settlement-status" data-status="paid">Registrada</span>
        </header>
        <dl>
          <div><dt>Referencia</dt><dd>{{ transfer.transfer_reference || 'Sin referencia' }}</dd></div>
          <div><dt>Registrada por</dt><dd>{{ transfer.performed_by_name }}</dd></div>
          <div><dt>Comentario</dt><dd>{{ transfer.notes || 'Sin comentario' }}</dd></div>
        </dl>
      </article>
    </div>
    <ng-template #emptySettlements>
      <div class="empty-row">Aún no existen transferencias registradas para este negocio.</div>
    </ng-template>
    <app-pagination [page]="data()?.settlements_page || 1" [pages]="settlementsPages()" [total]="data()?.settlements_total || 0" [limit]="data()?.settlements_limit || settlementsLimit()" [disabled]="loading()" itemLabel="liquidaciones" ariaLabel="Paginación de transferencias" (pageChange)="goToSettlementsPage($event)"></app-pagination>
  </section>

  <!-- Comisión pendiente (negocio -> TuSala): pestaña propia para que el
       detalle no empuje el resto del contenido hacia abajo cuando hay muchos
       periodos -- el resumen del periodo vigente sigue siempre visible
       arriba, en "Estado de cuenta". -->
  <section
    *ngIf="activeTab() === 'deuda'"
    id="panel-comision-pendiente"
    class="content-section tab-panel"
    role="tabpanel"
    aria-labelledby="tab-comision-pendiente"
  >
    <div class="section-heading">
      <div>
        <span class="eyebrow">DEUDA CON TUSALA</span>
        <h3>Comisión pendiente por periodo</h3>
        <p>Cuando el cliente te paga directo (efectivo, transferencia, etc.), TuSala no recibe nada vía pasarela para cubrir su comisión sobre esa reserva -- ese faltante se cierra aquí, periodo por periodo.</p>
      </div>
      <button
        type="button"
        class="action-btn"
        *ngIf="businessOwesCompany() > 0 && companyOwesBusiness() <= 0 && !pendingDebtSettlement()"
        [disabled]="closingCurrentDebt()"
        (click)="payCurrentDebtNow()"
      >{{ closingCurrentDebt() ? 'Generando enlace…' : 'Cerrar y pagar periodo vigente' }}</button>
    </div>

    <div class="debt-settlement-history" *ngIf="debtSettlements().length; else emptyDebtSettlements">
      <article class="debt-settlement-card" *ngFor="let s of debtSettlements()">
        <header class="debt-settlement-card-head">
          <div>
            <small>PERIODO FACTURADO</small>
            <strong>{{ s.period_start | esDate: 'mediumDate' }} – {{ s.period_end | esDate: 'mediumDate' }}</strong>
          </div>
          <span class="debt-status" [class.paid]="s.status === 'paid'">{{ s.status === 'paid' ? 'Pagado' : 'Pendiente' }}</span>
        </header>
        <dl class="debt-settlement-detail-grid">
          <div><dt>Total generado en el periodo</dt><dd>{{ s.total_gross_amount | currency: 'USD' }}</dd></div>
          <div><dt>Cobrado por TuSala (pasarela)</dt><dd>{{ s.platform_gross_amount | currency: 'USD' }}</dd></div>
          <div><dt>Cobrado por tu negocio (externo)</dt><dd>{{ s.external_gross_amount | currency: 'USD' }}</dd></div>
          <div><dt>Comisión ({{ s.commission_rate }}%) sobre el total</dt><dd>{{ s.commission_amount | currency: 'USD' }}</dd></div>
          <div class="debt-settlement-highlight"><dt>{{ s.status === 'paid' ? 'Monto pagado a TuSala' : 'Monto a pagar' }}</dt><dd>{{ s.amount_due | currency: 'USD' }}</dd></div>
        </dl>
        <footer class="debt-settlement-card-footer" *ngIf="s.status === 'paid'">
          <span><i class="bi bi-check-circle" aria-hidden="true"></i> Pagado por <strong>{{ s.payment_method }}</strong> el {{ s.paid_at | esDate: 'medium' }}</span>
          <span *ngIf="s.payment_reference">Referencia: {{ s.payment_reference }}</span>
        </footer>
        <footer class="debt-settlement-card-footer" *ngIf="s.status === 'pending'">
          <button
            type="button"
            class="action-btn"
            [disabled]="payingDebtSettlementId() === s.id"
            (click)="payDebtSettlementNow(s)"
          >{{ payingDebtSettlementId() === s.id ? 'Generando enlace…' : 'Pagar este periodo' }}</button>
        </footer>
      </article>
    </div>
    <ng-template #emptyDebtSettlements>
      <div class="empty-row">Todavía no se ha cerrado ningún periodo de comisión pendiente para este negocio.</div>
    </ng-template>
  </section>
</section>

<div class="modal-backdrop" *ngIf="modal() === 'create' || modal() === 'edit'" (click)="closeModal()">
  <section class="method-modal" role="dialog" aria-modal="true" aria-labelledby="method-modal-title" (click)="$event.stopPropagation()">
    <header>
      <div><span class="eyebrow">CONFIGURACIÓN SEGURA</span><h3 id="method-modal-title">{{ modal() === 'edit' ? 'Editar método' : 'Nuevo método de cobro' }}</h3><p>Los datos sensibles se almacenan cifrados.</p></div>
      <button type="button" class="icon-button" (click)="closeModal()" aria-label="Cerrar"><i class="bi bi-x-lg"></i></button>
    </header>
    <form (ngSubmit)="save(methodForm)" #methodForm="ngForm" #methodFormEl>
      <label class="full-field"><span>Nombre del método</span><input [(ngModel)]="form.label" name="label" placeholder="Ej. Cuenta principal" maxlength="80" required /></label>
      <label class="full-field">
        <span>Banco</span>
        <app-bank-select
          #bankSelect
          [bankId]="form.bank_id ?? null"
          [customName]="form.institution_name"
          [invalid]="bankSelectionError()"
          (bankIdChange)="form.bank_id = $event; bankSelectionError.set(false)"
          (nameChange)="form.institution_name = $event"
          (customNameChange)="bankSelectionError.set(false)"
        ></app-bank-select>
        <small *ngIf="bankSelectionError()" class="bank-selection-error">Selecciona un banco de la lista o elige "Otro" e ingresa el nombre.</small>
      </label>
      <label class="full-field"><span>Titular</span><input placeholder="Ej: María Fernanda López" [(ngModel)]="form.account_holder" (keydown)="blockNonLetters($event)" (paste)="onHolderPaste()" name="holder" maxlength="150" required /></label>
      <label><span>Número de cuenta</span><input [(ngModel)]="form.account_number" (keydown)="blockNonDigits($event)" (paste)="onAccountNumberPaste()" name="number" inputmode="numeric" autocomplete="off" required minlength="4" placeholder="Número completo de la cuenta" /></label>
      <label><span>Tipo de cuenta</span><select [(ngModel)]="form.bank_account_type" name="accountType"><option value="checking">Cuenta corriente</option><option value="savings">Cuenta de ahorro</option></select></label>
      <label class="check-field"><input type="checkbox" [(ngModel)]="form.is_primary" name="primary" /><span>Usar como método principal</span></label>
      <footer><button type="button" class="secondary-button" (click)="closeModal()">Cancelar</button><button type="submit" class="primary-button" [disabled]="saving()" cooldownBubble data-cooldown-key="ingresos-save-method">{{ saving() ? 'Guardando…' : 'Guardar método' }}</button></footer>
    </form>
  </section>
</div>

<div class="modal-backdrop" *ngIf="modal() === 'primary' || modal() === 'archive'" (click)="closeModal()">
  <section class="confirm-modal" role="alertdialog" aria-modal="true" (click)="$event.stopPropagation()">
    <span class="confirm-icon" [class.danger-icon]="modal() === 'archive'"><i [class]="modal() === 'archive' ? 'bi bi-trash3' : 'bi bi-star'"></i></span>
    <span class="eyebrow">CONFIRMA LA ACCIÓN</span>
    <h3>{{ modal() === 'archive' ? '¿Desactivar este método?' : '¿Cambiar el método principal?' }}</h3>
    <p *ngIf="modal() === 'primary'">Las próximas transferencias se dirigirán preferentemente a <strong>{{ selectedMethod()?.label }}</strong>.</p>
    <p *ngIf="modal() === 'archive'">Se ocultará <strong>{{ selectedMethod()?.label }}</strong> para operaciones futuras. Su historial permanecerá intacto.</p>
    <footer><button type="button" class="secondary-button" (click)="closeModal()">Cancelar</button><button type="button" [class]="modal() === 'archive' ? 'danger-confirm-button' : 'primary-button'" [disabled]="saving()" (click)="modal() === 'archive' ? confirmArchive() : confirmPrimary()" cooldownBubble [attr.data-cooldown-key]="modal() === 'archive' ? 'ingresos-archive' : 'ingresos-primary'">{{ saving() ? 'Procesando…' : 'Sí, confirmar' }}</button></footer>
  </section>
</div>
